const currentUrl = window.location.href;
const oldUrl = 'https://gstore.giikin.com';
const newUrl = 'https://manage.giikin.com/fe/gstore';

console.log(currentUrl.startsWith(oldUrl), currentUrl, oldUrl);
if (currentUrl.startsWith(oldUrl)) {
  console.log('自动跳转');
  // 将指定的部分替换为新的地址
  const toUrl = currentUrl.replace(oldUrl, newUrl);

  // 使用 replace 方法重定向，这样不会保留历史记录
  window.location.replace(toUrl);
}
